// Shared CSS transform string for canvas elements. Combines rotation with
// horizontal/vertical flip so every element type renders flips the same way.
// Used by CanvasEditor (commonStyle + the shape/svg/sticker cases) and the
// thumbnail renderer so canvas, thumbnails, and export stay in sync.
export function buildElementTransform(element) {
  const rotation = element?.rotation || 0;
  const sx = element?.flipX ? -1 : 1;
  const sy = element?.flipY ? -1 : 1;
  return `rotate(${rotation}deg) scale(${sx}, ${sy})`;
}
